<div class="m-auto-horizontal-scroll"
     :class="{
        'm--has-horizontal-scrollbar': hasHorizontalScroll,
        'm--has-left-gradient': hasLeftGradient,
        'm--has-right-gradient': hasRightGradient,
        'm--has-previous-button': hasPreviousButton,
        'm--has-next-button': hasNextButton,
        'm--is-gradient-style-white': isGradientStyleWhite,
        'm--is-gradient-style-light': isGradientStyleLight,
        'm--is-gradient-style-dark': isGradientStyleDark,
        'm--is-gradient-style-interactive': isGradientStyleInteractive,
    }"
     :style="componentHeightStyle">
    <transition name="m--is">
        <div v-if="hasPreviousButton || hasLeftGradient"
             class="m-auto-horizontal-scroll__button-area m--is-left"
             :style="buttonAreaHeightStyle">

            <m-icon-button v-if="hasPreviousButton"
                           ref="leftButton"
                           :skin="iconButtonSkin"
                           :ripple="false"
                           :title="previousButtonText"
                           icon-name="m-svg__chevron--left"
                           @click="emitPreviousButtonClick($event)" />
        </div>
    </transition>
    <transition name="m--is">
        <div v-if="hasNextButton || hasRightGradient"
             class="m-auto-horizontal-scroll__button-area m--is-right"
             :style="buttonAreaHeightStyle">
            <m-icon-button v-if="hasNextButton"
                           ref="rightButton"
                           :skin="iconButtonSkin"
                           :ripple="false"
                           :title="nextButtonText"
                           icon-name="m-svg__chevron--right"
                           @click="emitNextButtonClick($event)" />
        </div>
    </transition>
    <div ref="body"
         class="m-auto-horizontal-scroll__body"
         :class="{
                'm--is-dragging': isDragging && hasHorizontalScroll,
            }"
         @scroll="onScroll()"
         @mousedown="onMousedown($event)"
         @mouseleave="onMouseleave()"
         @mouseup="onMouseup()"
         @mousemove="onMousemove($event)">
        <div ref="bodyContent"
             class="m-auto-horizontal-scroll__body-content"
             :style="{ minWidth: minWidth }">
            <slot />
        </div>
    </div>
</div>
